// extracted by mini-css-extract-plugin
module.exports = {"Slider":"HeroSlider_Slider___C2VA","playing":"HeroSlider_playing__8Yhtw"};